

  // Achievement data
export const achievements = [
    {
      id: 1,
      name: 'System Architect',
      description: 'Designed and implemented distributed systems',
      icon: '🏗️',
      rarity: 'legendary',
      unlocked: true
    },
    {
      id: 2,
      name: 'Performance Wizard',
      description: 'Optimized systems for maximum efficiency',
      icon: '⚡',
      rarity: 'epic',
      unlocked: true
    },
    {
      id: 3,
      name: 'API Master',
      description: 'Created 50+ production-ready APIs',
      icon: '🔌',
      rarity: 'rare',
      unlocked: true
    },
    {
      id: 4,
      name: 'Microservice Pioneer',
      description: 'Successfully decomposed monolithic applications',
      icon: '🧩',
      rarity: 'epic',
      unlocked: true
    },
    {
      id: 5,
      name: 'Data Pipeline Engineer',
      description: 'Built robust ETL and data processing systems',
      icon: '🔄',
      rarity: 'rare',
      unlocked: true
    },
    {
      id: 6,
      name: 'Cloud Native Warrior',
      description: 'Deployed and managed cloud infrastructure',
      icon: '☁️',
      rarity: 'legendary',
      unlocked: true
    }
  ];
